import { render, staticRenderFns } from "./CadastroEmpresasForm.vue?vue&type=template&id=39d3af09&scoped=true&"
import script from "./CadastroEmpresasForm.vue?vue&type=script&lang=js&"
export * from "./CadastroEmpresasForm.vue?vue&type=script&lang=js&"
import style0 from "./CadastroEmpresasForm.vue?vue&type=style&index=0&id=39d3af09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3af09",
  null
  
)

export default component.exports